import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* updateRegularusersGroup({ payload: { id, values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.regularusers.update, id, data: values });

    onSuccess && onSuccess();
    yield put(actions.updateRegularusersGroupDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.updateRegularusersGroupFailed,
      handledErrors,
      endpoint: api.modifiers.regularusers.update.url
    });
  }
}

export const updateRegularusersGroupSaga = takeEvery(types.UPDATE_REGULARUSERS_GROUP_REQUEST, updateRegularusersGroup);